// eslint-disable-next-line import/no-anonymous-default-export
export default {
  primary: "#172128",
  secondary: "#17212820",
  veryLightGray: "#bababa",
  redShade: "#aa000020",
  greenShade: "#00aa0020",
  blue: "#0055bb",
  silver: "silver",
};
